import { render } from "./BannerColour.vue?vue&type=template&id=b90a5010&scoped=true"
import script from "./BannerColour.vue?vue&type=script&lang=js"
export * from "./BannerColour.vue?vue&type=script&lang=js"

import "./BannerColour.vue?vue&type=style&index=0&id=b90a5010&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b90a5010"]])

export default __exports__